module.exports = __webpack_public_path__ + "media/images/trix_embed-b12d25a45b6654eaf2429c1bb4c95822.svg";